import React from 'react';
import { Toaster } from 'react-hot-toast';

// Mounted once, at the app root. Individual components call the helpers in
// ./notify rather than rendering anything themselves.
const Notifications = () => (
  <Toaster
    position="bottom-center"
    toastOptions={{
      duration: 4000,
      style: {
        background: '#003366',
        color: '#ffffff',
        fontSize: '0.95rem',
        maxWidth: '90vw',
      },
      success: { iconTheme: { primary: '#4ade80', secondary: '#003366' } },
      error: { duration: 6000, iconTheme: { primary: '#f87171', secondary: '#003366' } },
    }}
  />
);

export default Notifications;
